import { makeImmutable } from "../core";
export class OrderLineReference {
    constructor(params) {
        this.orderLineIndex = params.orderLineIndex;
        this.productInstanceIndex = params.productInstanceIndex;
        this.productInstance = params.productInstance;
        makeImmutable(this);
    }
    static fromStorageData({ purchaseOrderPayload, storageData, }) {
        const orderLine = purchaseOrderPayload.orderLines.find(storageData.orderLineIndex);
        if (orderLine === null ||
            storageData.productInstanceIndex >= orderLine.quantity.value) {
            return null;
        }
        return new OrderLineReference({
            orderLineIndex: storageData.orderLineIndex,
            productInstanceIndex: storageData.productInstanceIndex,
            productInstance: orderLine.productInstance,
        });
    }
    eq(other) {
        return (this.orderLineIndex === other.orderLineIndex &&
            this.productInstanceIndex === other.productInstanceIndex);
    }
    /**
     * Position *and* configuration.
     *
     * The solver assigns discount sources and targets by the price of the
     * referenced product, so an order line edited in place - same index, same
     * quantity, different configuration - has to read as a different reference.
     * Comparing by position alone leaves the solver asleep and the promotion
     * holding an assignment computed from prices that no longer exist.
     */
    eqWithProductInstance(other) {
        return this.eq(other) && this.productInstance.eq(other.productInstance);
    }
    get storageData() {
        return {
            orderLineIndex: this.orderLineIndex,
            productInstanceIndex: this.productInstanceIndex,
        };
    }
}
